import { quickOrderStyles } from "@insite/content-library/Widgets/Basic/QuickOrder";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@store/theme/common/design";
import { borderBottomTitlesStyles } from "@store/theme/common/mixins";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(quickOrderStyles, {
    container: {
        gap: 0,
        css: css`
            ${borderBottomTitlesStyles()}
            margin-top: 20px;
            margin-bottom: 20px;
        `,
    },
    titleText: {
        variant: "h2",
        css: css`
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["10px !important", "0 !important", null, null, null], properties: ["margin-bottom"] }],
                    mediaOptions.min,
                )}
        `,
    },
    linksGridItem: {
        width: [12, 7, 7, 7, 7],
        css: css`
            align-items: center;

            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [
                        {
                            values: [null, "flex-end", null, null, null],
                            properties: ["justify-content"],
                        },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    orderUploadLink: {
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
            css: css`
                text-decoration: underline;

                &:hover,
                &:focus {
                    text-decoration: none;
                }
            `,
        },
    },
    orderMultipleItemsLink: {
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
            css: css`
                text-decoration: underline;

                &:hover,
                &:focus {
                    text-decoration: none;
                }
            `,
        },
        css: css`
            margin-left: 20px;
        `,
    },
    productSelector: {
        searchGridItem: { width: [9, 9, 7, 7, 7] },
        qtyGridItem: { width: [3, 3, 2, 2, 2] },
        unitOfMeasureGridItem: { width: 0 },
        buttonGridItem: { width: [12, 12, 3, 3, 3] },
        selectButton: {
            css: css`
                width: 100%;
                align-self: flex-end;
                margin-bottom: 10px;
            `,
        },
    },
});
